<div class="dialog">
  <div class="dialog-background"></div>
  <div class="dialog-content">
    <h1 class="txt-center">{{ 'ODD.overlay.title' | translate: { first_name: name } }}</h1>
    <p [innerHTML]="'ODD.overlay.description' | translate: { days: days, date: date }"></p>
    <app-ui-info-box status="warning">
      <p>
        <strong>{{ 'ODD.overlay.callout.title' | translate }}</strong>
      </p>
      <p>{{ 'ODD.overlay.callout.description.intro' | translate }}</p>
      <ul>
        <li [innerHTML]="'ODD.overlay.callout.description.li1' | translate"></li>
        <li [innerHTML]="'ODD.overlay.callout.description.li2' | translate"></li>
      </ul>
    </app-ui-info-box>
    <div class="ui-button-group">
      <button (click)="onReview()" class="ui-button" type="button">
        {{ 'ODD.overlay.buttons.review' | translate }}
      </button>
      <button (click)="onDoItLater()" class="ui-button secondary" type="button">
        {{ 'ODD.overlay.buttons.postpone' | translate }}
      </button>
    </div>
  </div>
</div>
